import {AbstractControl, ValidationErrors} from '@angular/forms';
import {UserRolesEnum} from '../user-roles.enum';
import {Country} from '../../country/country';

export function practitionerCountryValidator(control: AbstractControl): ValidationErrors | null {
  if (control.get('role')?.value === UserRolesEnum.PRACTITIONER) {
    if (!(control.get('country')?.value instanceof Country)) {
      control.get('country')?.setErrors({incorrect: true});
    } else {
      control.get('country')?.setErrors(null);
    }
  } else {
    control.get('country')?.setErrors(null);
  }
  return null;
}
